import { render } from "./AppTextarea.vue?vue&type=template&id=46e94e22"
import script from "./AppTextarea.vue?vue&type=script&lang=js"
export * from "./AppTextarea.vue?vue&type=script&lang=js"

import "./AppTextarea.vue?vue&type=style&index=0&id=46e94e22&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__